module.exports = __webpack_public_path__ + "static/media/redTheme-boy.45d48b36.svg";